var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { setInstrument } from "../../../../../../../redux/actions/canvas/canvas";
export var Shapes = function () {
    var instrument = useSelector(function (state) { return state.canvas; }).instrument;
    var instrumentToggle = function () { return setInstrument('shapes'); };
    return (_jsx(Button, __assign({ onClick: instrumentToggle, className: clsx("remove-button-text", {
            active: instrument === "shapes",
        }) }, { children: _jsxs("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M10 3 L15 9 H5 Z", stroke: "currentColor", strokeWidth: "1", fill: "none", strokeLinejoin: "round" }), _jsx("rect", { x: "4", y: "11", width: "5", height: "5", rx: "1", stroke: "currentColor", strokeWidth: "1", fill: "none" }), _jsx("circle", { cx: "14", cy: "13.5", r: "2.5", stroke: "currentColor", strokeWidth: "1", fill: "none" })] })) })));
};
